import React from 'react';
import MachineAddEditModal from './machine-add-edit';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { MACHINE_ADD_EDIT } = MODAL_TYPES;

const MachineModals = () => {
  return (
    <>
      <MachineAddEditModal modalId={MACHINE_ADD_EDIT} />

    </>
  );
};

export default MachineModals;
